import { ProfileAvatar } from 'components/Atoms/ProfileAvatar'
import { useUser, useUserUpdaters } from 'hooks/user/useUser'
import axios from 'axios'
import { API } from 'constants/apiEndPoints'
import { AvatarFormCSS } from './AvatarFormCSS.styled'

export const AvatarForm = () => {
  const { updateUserProfile } = useUserUpdaters()
  const { avatar } = useUser('profile')
  const { accessToken } = useUser('wallet')

  const updateAvatar = (e) => {
    const avatarFile = e.target.files[0]

    const formData = new FormData()
    formData.append('file', avatarFile)

    const headers = {
      Authorization: `Bearer ${accessToken}`,
      'content-type': 'multipart/form-data'
    }

    axios
      .post(API.ACCOUNT_UPLOAD_AVATAR, formData, { headers })
      .then((response) => {
        const avatar = response?.data?.response?.body?.avatarUrl
        updateUserProfile({ avatar })
      })
      .catch((err) => {
        console.log('ACZ err -->', JSON.parse(JSON.stringify(err)))
      })
  }
  return (
    <AvatarFormCSS avatar={avatar}>
      <div className='avatar_form'>
        <input accept='image/*' type='file' id='select-image' style={{ display: 'none' }} onChange={updateAvatar} />
        <label htmlFor='select-image'>
          <div className='avatar_form_edit'>EDIT</div>
          <ProfileAvatar className='profile_avatar' avatar={avatar} />
        </label>
      </div>
    </AvatarFormCSS>
  )
}
